


















































































































































import { Component, Mixins, Inject, Vue } from "vue-property-decorator";

import {
  ITemplatesProviderData,
  ITemplatesProviderMethods
} from "@/models/providers/templates";

@Component({
  components: {
    "actions-table-row": () =>
      import("@/components/app/admin/automation/actionTableRow.vue"),
    "template-preview-dropdown": () =>
      import("@/components/app/global/templates/templatePreviewDropdown.vue")
  }
})
export default class ClientTemplatesTemplatesListing extends Mixins(Vue) {
  // Inject

  @Inject({ from: "templatesProvider" })
  public templatesProvider!: () => ITemplatesProviderData;

  @Inject({ from: "templatesProviderMethods" })
  public $templatesMethods!: ITemplatesProviderMethods;

  // Computed

  public get $templatesData() {
    return this.templatesProvider();
  }

  public get table() {
    return this.$templatesData.table;
  }
}
